import axios from '../config/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api` || 'http://localhost:7000/api';

// Which tool a study opens in (Design Studio / Document Authoring Tool) is
// project/study-level, shared state — the same for every user on a given
// study — not a per-user preference. See study-open-preference routes,
// mirroring studyDesignSelection.service.js's shape.
const studyOpenPreferenceService = {
  // Load the saved open mode for a project, or null if none has been chosen yet.
  getPreference: async (projectId) => {
    try {
      const response = await axios.get(`${API_URL}/study-open-preference/${projectId}`);
      return response.data?.openMode || null;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Save the open mode for a project (shared across all users of that project).
  // Create-once: if another user already set a preference for this project
  // (including one that just won a race against this same call), the backend
  // keeps that existing value instead of overwriting it. `applied` tells the
  // caller whether their own requested mode is the one that was actually
  // stored — `openMode` is always the true, current value either way.
  savePreference: async (projectId, openMode) => {
    try {
      const response = await axios.put(`${API_URL}/study-open-preference/${projectId}`, { openMode });
      return {
        openMode: response.data?.openMode || openMode,
        applied: response.data?.applied !== false,
      };
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Reset the open mode for a project so it behaves like one that has never
  // had a preference selected — the next PUT for this project (from whoever
  // opens it next) is free to set a new shared value.
  resetPreference: async (projectId) => {
    try {
      await axios.delete(`${API_URL}/study-open-preference/${projectId}`);
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default studyOpenPreferenceService;
